import { render, staticRenderFns } from "./ProcedureReportFilter.vue?vue&type=template&id=572613a6&scoped=true&"
import script from "./ProcedureReportFilter.vue?vue&type=script&lang=js&"
export * from "./ProcedureReportFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureReportFilter.vue?vue&type=style&index=0&id=572613a6&prod&lang=scss&"
import style1 from "./ProcedureReportFilter.vue?vue&type=style&index=1&id=572613a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572613a6",
  null
  
)

export default component.exports